import { PaletteMode } from '@mui/material';

const dark = {
  base00: '#0D1729',
  base01: '#16223A',
  base02: '#27385C',
  base03: '#5E74B0',
  base04: '#7C90BE',
  base05: '#C8D4F0',
  base06: '#DFE7FF',
  base07: '#8BACFF',
  base08: '#F0728A',
  base09: '#8BE8A8',
  base0A: '#E0C24E',
  base0B: '#E0A32E',
  base0C: '#5FD0C9',
  base0D: '#8BACFF',
  base0E: '#B79CF0',
  base0F: '#E0A32E',
};

const light = {
  base00: '#FFFFFF',
  base01: '#EEF1F9',
  base02: '#D5DCEC',
  base03: '#9AA3C0',
  base04: '#6B7A99',
  base05: '#3A4568',
  base06: '#232D4A',
  base07: '#4C60C9',
  base08: '#D12A44',
  base09: '#157F44',
  base0A: '#8A6412',
  base0B: '#B4761E',
  base0C: '#0E8F87',
  base0D: '#4C60C9',
  base0E: '#7C57C8',
  base0F: '#B4761E',
};

export const getJsonViewTheme = (mode: PaletteMode) => (mode === 'dark' ? dark : light);
